import 'vuetify/dist/vuetify.min.css'
import 'leaflet/dist/leaflet.css'
import './main.css'

import 'babel-polyfill'

import Vue from 'vue'
import Vuetify from 'vuetify'

import VueObserveVisibility from 'vue-observe-visibility'

import App from './App'
import router from './router'
import store from './store'
import filters from './filters'
import auth from './auth'

require('es6-promise/auto')
require('intersection-observer')

Vue.config.productionTip = false

Vue.use(Vuetify, {
  theme: {
    primary: '#FA3138',
    secondary: '#666666',
    accent: '#66ABCF',
    tertiary: '#57AEA6'
  }
})

Vue.use(VueObserveVisibility)

Object.keys(filters).forEach((key) => {
  const type = filters[key]
  Object.keys(type).forEach(k => Vue.filter(k, type[k]))
})

Vue.use(auth)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
  mounted () {
    setTimeout(() => {
      document.dispatchEvent(new Event('render-event'))
    }, 10000)
  }
})



// WEBPACK FOOTER //
// ./src/main.js